'use client';

import { AdSlot } from '@/app_components/AdSlot/Adslot';
import { useAdContext } from '@/app_lib/providers/AdProvider';
import { ContentPlacement } from '@/app_lib/types/analytics';
import { cn } from '@/app_lib/utils/utils';

interface RightRailFlexProps {
  sticky?: boolean;
  index?: number;
}

export const RightRailFlex = ({ sticky = false, index }: RightRailFlexProps) => {
  const { pageAdConfig } = useAdContext();
  return (
    <div className={cn(sticky ? 'h-full' : 'h-[var(--rail-flex-height)] w-[var(--rail-flex-width)]')}>
      {/* Height of the right rail flex ad container */}
      <div
        className={cn(
          sticky && 'sticky top-[calc(var(--leaderboard-height)+var(--header-height)+var(--disclaimer-height))]',
        )}
        data-cy={ContentPlacement.RightRailFlex}
      >
        {pageAdConfig && (
          <AdSlot
            index={index}
            placementName='RightRailFlex'
            sticky={sticky}
          />
        )}
      </div>
    </div>
  );
};
